import {
  Building2,
  Package,
  Settings2,
  ShieldCheck,
  CircleHelp,
} from 'lucide-react';
import { ORDER_VIEWS } from '../../orders/order-views/orderViews';
import type { SideMenuAccordionConfig } from './side-menu.types';

export const SIDE_MENU_DATA: SideMenuAccordionConfig[] = [
  {
    icon: Building2,
    eventKey: '0',
    title: 'Properties',
    routePermission: 'Properties',
    subMenuList: [
      { title: 'All Properties', route: 'properties', tabIndex: 1 },
    ],
  },
  {
    icon: Package,
    eventKey: '1',
    title: 'Orders',
    routePermission: 'Order',
    subMenuList: ORDER_VIEWS.map((v, i) => ({
      title: v.name,
      route: 'orders',
      view: v.key === 'all' ? undefined : v.key,
      tabIndex: 3 + i, // 3..6
    })),
  },
  {
    icon: Settings2,
    eventKey: '2',
    title: 'Integrations',
    routePermission: 'Integration',
    subMenuList: [
      { title: 'Manage Integrations', route: 'integrations', tabIndex: 7 },
    ],
  },
  {
    icon: ShieldCheck,
    eventKey: '3',
    title: 'Administration',
    routePermission: 'External user',
    subMenuList: [
      { title: 'Team Members', route: 'team-members', tabIndex: 8 },
    ],
  },
  {
    icon: CircleHelp,
    eventKey: '5',
    title: 'Help & Support',
    routePermission: 'Help',
    bottom: true,
    subMenuList: [
      { title: 'FAQ', route: 'help-and-support/faq', tabIndex: 9 },
      { title: 'Contact Us', route: 'help-and-support/contact', tabIndex: 10 },
    ],
  },
];
